function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP page footer component
 * 
 */
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { FOOTER } from './Footer.content';
import { connect } from 'react-redux';
import './Footer.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class Footer extends React.Component {
  render() {
    const {
      cookies
    } = this.props;
    const {
      copyright,
      links
    } = FOOTER;
    const {
      pathname
    } = window.location;
    const path = pathname.substr(1);
    const copyright_notice = path === 'confirmation' ? copyright.confirmation : copyright.default;
    return /*#__PURE__*/_jsx("footer", {
      className: `${!cookies ? 'has-cookies' : ''} ${path}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: "inner",
        children: [/*#__PURE__*/_jsx("div", {
          className: "logo",
          children: /*#__PURE__*/_jsx("img", {
            src: '/images/logo-aaa2.png',
            alt: ""
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "copyright",
          children: copyright_notice
        }), /*#__PURE__*/_jsx("ul", {
          className: "footer-links",
          children: links.map((item, index) => {
            const {
              link,
              text
            } = item;
            return /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx("a", {
                href: link,
                target: "_blank",
                rel: "noopener noreferrer",
                children: text
              })
            }, index);
          })
        })]
      })
    });
  }
}
_defineProperty(Footer, "defaultProps", {
  cookies: false
});
const mapStateToProps = cookies => {
  return cookies;
};
const VisibleFooter = connect(mapStateToProps)(Footer);
export default withRouter(VisibleFooter);